import { Container } from 'react-bootstrap'

import NavbarPages from '../NavbarPages'
import HeaderPages from '../HeaderPages'
import KiveUso from '../../../Resourses/products/rami-uso-general-papel.svg'

const imgHeader = "./images/productos/header-internas-rami-papel.jpg";
const imgThumbIzq = "./images/productos/productos_thumbs--cinta-papel-rami.jpg";
const altText = "CINTA DE EMPAQUE";

const tipoColor = 'productos__detail--tipoPapelRami'

const detailLine1 = "CINTAS";
// const detailLine2 = "ADHESIVA";
const detailLine3 = "DE PAPEL";

const imgTable ="./images/productos/rami/cuadro-rami-cinta-papel.jpg";


const textoDetail = 'Cinta de enmascarar de uso general desarrolladas para el uso diario, siendo ideales para trabajos escolares , empalmes, rotular, decoración, etc...'

const imgThumb1 = './images/productos/rami/rami-cinta-de-papel-1.jpg';
const imgThumb1Alt = 'Cintas papel 36.';

const imgThumb2 = './images/productos/rami/rami-cinta-de-papel-2.jpg';
const imgThumb2Alt = 'Cintas papel 24.';

const imgThumb3 = './images/productos/rami/rami-cinta-de-papel-3.jpg';
const imgThumb3Alt = 'Cintas adhesivas de empaque a granel.';

const CintaPapelRami = () => {
  return (
    <Container className='mb-0'>
        <NavbarPages className="p-0" />
        <div className='row'>
          <div className='col-12 mb-4'>
            <HeaderPages img={imgHeader} alt={"Productos Kive Cintas"} />
          </div>
          <div className='col-12 col-sm-6 col-md-5 productos__imgContainer'>
            <img 
              src={imgThumbIzq} 
              alt={altText} 
              className='d-block w-100 productos__imgContainer--img' 
              loading='lazy'/>
          </div>
          <div className='col-12 col-sm-12 col-md-7 productos__vert--int mb-4 mt-1'>
            <div className='row productos__detail'>
              <div className='col-12'>
                <p className={`productos__detail--tipo ${tipoColor}`}>{detailLine1}
                 {/* <span className={`productos__detail--caracteristica ${tipoColor}`}> {detailLine2}</span> */}
                </p>
                <p className={`productos__detail--caracteristica ${tipoColor}`}>{detailLine3}</p>
                <img src={KiveUso} className='d-block productos__detail--svg' alt='' loading="lazy" />
              </div>
              <div className='col-12 productos__detail'>
                <img  src={imgTable} 
                      className='d-block w-100' 
                      alt={altText}
                      loading="lazy" />
              </div>
            </div>
          </div>
          <div className='col-12 col-sm-12 col-md-12 productos__vert mb-4 mt-1'>
            <p className='site_text productos__text--int mb-0'> 
              {textoDetail}
            </p>
          </div>
        </div>
        <div className='row'>
        
            <div className='col-12 col-sm-12 col-md-6 col-lg-4 mb-4' >
              <img src={imgThumb1} className='d-block w-100 p-0 m-0 ' alt={ imgThumb1Alt} loading="lazy" />
            </div>
            <div className='col-12 col-sm-12 col-md-6 col-lg-4 mb-4' >
              <img src={imgThumb2} className='d-block w-100 p-0 m-0 ' alt={ imgThumb2Alt} loading="lazy" />
            </div>
            <div className='col-12 col-sm-12 col-md-6 col-lg-4 mb-4' >
              <img src={imgThumb3} className='d-block w-100 p-0 m-0 ' alt={ imgThumb3Alt} loading="lazy" />
            </div>
           
        </div>       
      </Container>
    
  )
}

export default CintaPapelRami